<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ctOQAt/tc-custom/9781468310504.jpg?1738468531123" alt="This image is the cover for the book Saints of New York"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Saints of New York
      </h1>
      <p class="bookDescription body article font2">
        <b>In the hunt for a serial killer, an NYPD detective’s suspicion verges on obsession in this “meaty, beautifully written crime novel” (<i>Publishers Weekly</i>, starred review).</b><br/><br/>Detective Frank Parrish barely notices the death of a young heroin dealer—just another casualty of the drug war. But when the dealer’s sister turns up as the first of many corpses, Frank must try to make sense of the disturbingly uniform deaths, all while battling his own demons. Frank is the son of a legendary NYPD detective, one of the original “Saints of New York” who cleaned up the Mafia in the 1980s. <br/><br/>As the murders accelerate, Frank struggles to fulfill the legacy of his father and piece together not only his case, but also his life. Dark and intense, <i>Saints of New York</i> is a novel of corruption and redemption, of relentless persistence to find the truth, and of one man’s search for meaning amidst the ghosts of his own conscience.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R.J. Ellory
      </h2>
      
      <p class="authorDescription body article">R.J. Ellory is the author of twelve novels, including the bestselling A Quiet Belief in Angels, which was Strand Magazine's Thriller of the Year, shortlisted for the Barry Award, and a finalist for the SIBA Award. He is also the author of City of Lies, Candlemoth, A Quiet Vendetta, A Simple Act of Violence, and the e-book original series Three Days in Chicagoland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7159052e